import React from "react";
import { Mobile, TabletOrDesktop } from "utils/responsive";
import Plan from "pages/Plan";
import MobilePlanView from "components/Plans/Mobile/MobilePlanView";
import Layout from "components/Layout";

/**
 * Vista simple solo en móvil (≤767px). Tablet/TPV/escritorio usan la grilla,
 * aunque tengan pantalla táctil o el menú hamburguesa del Layout (988px).
 */
const PlanResponsive = (props) => {
	const routeGroupId = props.match?.params?.group
		? parseInt(props.match.params.group)
		: undefined;

	return (
		<>
			<TabletOrDesktop>
				<Plan {...props} />
			</TabletOrDesktop>
			<Mobile>
				<Layout>
					<MobilePlanView routeGroupId={routeGroupId} />
				</Layout>
			</Mobile>
		</>
	);
};

export default PlanResponsive;
